const LOGTAIL_TOKEN = `${process.env.REACT_APP_LOGTAIL_TOKEN}`;

export function logtailLog(message, level = "info", metadata = {}) {

    console.log('### token logtail: ', LOGTAIL_TOKEN)

    const msgText = typeof message === "object" ? JSON.stringify(message) : message;

    return fetch("https://s1353192.eu-nbg-2.betterstackdata.com/", {
        method: "POST",
        headers: {
            Authorization: `Bearer ${LOGTAIL_TOKEN}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            message: msgText,
            level,
            ...metadata,
            source: "res1000-app-hml",
            timestamp: new Date().toISOString()
        })
    }).catch((err) => {
        console.warn("Erro ao enviar log para Logtail:", err);
    });
}